import browser from 'browser-detect';

export default function windowStop() {
  let res = browser()

  /**
  |--------------------------------------------------
  | SAFARI NOT SUPPORT WINDOW.STOP, for more detail 
  | url: https://developer.mozilla.org/en-US/docs/Web/API/Window/stop
  |--------------------------------------------------
  */
  if(res.name === 'safari') return null
  window.stop()
}


// WEBPACK FOOTER //
// ./src/App/utils/windowStop.js